import { EventPayloadCrud } from '../../../controller-classes';
import { getKitchenReferenceRules } from '../helpers';
import { ReferenceMap } from '../../public.types';
import { toCamelCase } from '../../../helpers';
import { validationsMap } from '../validations/validations-map';

/**
 * Runs only the validation half of the rule sweep. Pairs with `applyActionRulesCfn`,
 * which runs both action rules and validations. Used by events whose intent is to
 * refresh warning state (e.g. `panel_item_full_height`) without re-firing idempotent-
 * at-equilibrium action rules like the fridge trim-kit sync, which would otherwise
 * delete the companion C124TK / CBIR24TK / C121TK / CBIR21TK / CRTA21TK / C115TK trim
 * kit the moment counts land equal.
 */
export const applyValidationRulesCfn = (ruleScope: number, params: EventPayloadCrud<unknown, ReferenceMap>): void => {
	const itemRules = getKitchenReferenceRules({ ruleScope, refMap: params.ref });

	for (const itemVal of itemRules.validation) {
		if (itemVal) {
			const val = validationsMap[toCamelCase(itemVal)] ?? null;

			if (val) {
				val.func({ refMap: params.ref });
			} else {
				console.warn(`rule:validation:-- ${itemVal}`, 'invalid validation rule');
			}
		}
	}
};
